import { useState, lazy, Suspense } from 'react'
import Img from 'react-image'
import { dateWithoutTime } from '../../../lib/time'
import { AddToGarageModalButton } from '../../../components/AddToGarage/AddToGarageModalButton'
import { PremiumRibbon } from '../../../AccountV2/components/WizardForm/PremiumRibbon'
import { PremiumBadge } from '../../../AccountV2/components/WizardForm/PremiumBadge'
const AuctionTime = lazy(() => import('./AuctionTime'))

/* eslint-disable camelcase */
const ListItem = ({
  car_path,
  webp_image,
  image,
  auctioned,
  auction_active,
  title,
  price,
  currency,
  auction_start_at,
  auction_end_at,
  location_country,
  published,
  openGarageModal,
  id,
  details,
  distance,
  mobileDetails,
  withSoldMark,
  isPremium = false
}) => {
  const [showDescription, setShowDescription] = useState(false)

  const handleShowDescription = () => {
    setShowDescription(!showDescription)
  }

  return (
    <div className='flat-card list-card my-2'>
      <div className='d-flex'>
        <a
          href={car_path}
          target={App.State.isMobile ? '_self' : '_blank'}
          rel='noreferrer'
        >
          <div className='car-list-card-image-container position-relative'>
            <Img
              src={App.State.supportsWebp && webp_image ? webp_image : image}
              alt={title}
              className='car-list-card-image'
              loader={
                <img
                  src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mN8+ertfwAJRQPBTZk8XgAAAABJRU5ErkJggg=='
                  width={240}
                  height={180}
                  className='car-list-card-image'
                  alt={title}
                />
              }
            />

            <div
              className='d-flex'
              style={{ position: 'absolute', top: '10px', left: '10px' }}
            >
              {location_country && (
                <div className='badge bg-white text-dark'>
                  <span
                    className={`flag-icon flag-icon-${location_country?.toLocaleLowerCase()}`}
                  />
                  <span className='mx-1 text-dark'>{location_country}</span>
                </div>
              )}

              {withSoldMark && (
                <div className='badge ms-2 bg-danger text-white'>
                  <i className='fa-solid fa-sack-dollar me-1' />
                  {I18n.t('sold')}
                </div>
              )}
            </div>

            {isPremium && (
              <div
                style={{
                  position: 'absolute',
                  top: '10px',
                  right: '0px',
                  marginRight: '-6px'
                }}
                className='d-none d-md-block'
              >
                <PremiumRibbon size={'sm'} />
              </div>
            )}
          </div>
        </a>
        <div
          className='px-3 py-2 card-content-container w-100 text-dark'
          style={{ minWidth: 0 }}
        >
          <div className='d-flex justify-between align-items-center'>
            <div style={{ minWidth: 0 }}>
              <a
                href={car_path}
                target={App.State.isMobile ? '_self' : '_blank'}
                rel='noreferrer'
              >
                <div className='card-title d-flex' style={{ minWidth: 0 }}>
                  <p className='my-0 text-truncate text-dark'>{title}</p>
                  {(auction_active || auctioned) && (
                    <div>
                      <div className='badge bg-primary d-inline-block mx-1'>
                        {I18n.t('auction')}
                      </div>
                    </div>
                  )}
                </div>
              </a>
            </div>
            {published && (
              <AddToGarageModalButton
                classes='text-neutral p-0 ms-auto'
                onButtonClick={openGarageModal}
                carId={id}
              />
            )}
          </div>
          <a
            href={car_path}
            target={App.State.isMobile ? '_self' : '_blank'}
            rel='noreferrer'
          >
            <div className='card-price-container d-flex flex-column flex-md-row text-dark'>
              {!price && !auction_active && !auctioned && (
                <span
                  title={I18n.t('price_on_request')}
                  className='font-heading'
                >
                  {I18n.t('price_on_request')}
                </span>
              )}

              {price > 0 && !auction_active && !auctioned && (
                <span className='font-heading'>
                  {String(price).replace(/(\d)(?=(\d{3})+$)/g, '$1 ')}{' '}
                  {currency}
                </span>
              )}

              {auctioned && (
                <span className='font-heading'>
                  Starts {dateWithoutTime(new Date(auction_start_at * 1000))}
                </span>
              )}

              {auction_active && (
                <Suspense fallback={<div>{I18n.t('loading')}</div>}>
                  <AuctionTime auctionEndAt={auction_end_at} />
                </Suspense>
              )}

              {distance && (
                <div className='text-dark my-1 my-md-0 mx-0 mx-md-1'>
                  <i className='fas fa-map-marker-alt fa-fw text-danger' />~
                  {distance} away
                </div>
              )}
            </div>
          </a>
          <div className='card-details-container mt-2'>
            <p className='d-none d-md-block text-dark mb-1'>{details}</p>
          </div>
        </div>
      </div>
      {mobileDetails && (
        <div>
          <hr className='d-md-none p-0 m-0' />
          <div
            className='list-description-wrapper d-md-none'
            onClick={handleShowDescription}
          >
            <div className='d-flex justify-content-between p-3'>
              <span
                className={`text-muted d-inline-block${
                  !showDescription ? ' text-truncate' : ''
                }`}
              >
                {isPremium && <PremiumBadge size={'sm'} />}
                {mobileDetails}
              </span>
              <span className='d-inline-block'>
                <button
                  className='btn btn-sm p-0 ms-1 text-primary'
                  type='button'
                  aria-label='Show details'
                >
                  {showDescription && (
                    <i className='far fa-chevron-up fa-lg ms-1' />
                  )}
                  {!showDescription && (
                    <i className='far fa-chevron-down fa-lg ms-1' />
                  )}
                </button>
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default ListItem
